module.exports = "<app-chips-basic [label]=\"labelTags\" \n[items]=\"tagItems\"\n (notify)=\"setClickTagItem($event)\">\n</app-chips-basic>\n"